import type { NotificationEventType } from '@cgp/shared'
import { apiRequest } from './api-client'

export type NotificationRow = {
  id: string
  userId: string
  eventType: NotificationEventType
  titleEn: string
  titleVi: string
  bodyEn: string | null
  bodyVi: string | null
  entityType: string | null
  entityId: string | null
  isRead: boolean
  readAt: string | null
  createdAt: string
}

export type NotificationsPage = {
  rows: NotificationRow[]
  nextCursor: string | null
  unreadCount: number
}

export const notificationsApi = {
  list: (params: { unreadOnly?: boolean; cursor?: string; pageSize?: number } = {}) =>
    apiRequest<NotificationsPage>('/notifications', { query: params }),
  markRead: (id: string) => apiRequest<NotificationRow>(`/notifications/${id}/read`, { method: 'PATCH' }),
  markAllRead: () => apiRequest<{ updated: number }>('/notifications/read-all', { method: 'POST' }),
}
